//
//
//
//
//
//
//

export default {
  props: {
    list: { // 列表
      type: Array, default: () => ([])
    }
  },
  data () {
    return {
      renderDom: '' // 渲染的dom
    }
  },
  computed: {
    // 首页
    breadHost () {
      return this.$store.getters.breadHome
    }
  },
  created () {
    this.renderDom = !this.filterSpecial() ? `<a href="${this.breadHost}" target="_blank">${this.$t('TYY_000005')}</a><span class="next-symbol">-</span>` : ''
  },
  mounted () {
    this.renderDom += `<a href="/${this.currLangCode()}" target="_blank">VPS</a><span class="next-symbol">-</span>`
    this.initBread()
  },
  methods: {
    // 初始化面包屑导航
    initBread () {
      for (let i = 0; i < this.list?.length; i++) {
        const item = this.list[i]
        if (i >= this.list?.length - 1) {
          this.renderDom += `<span class="current">${item.name}</span>`
          break
        }
        this.renderDom += `<a href="/${this.currLangCode() + item.url}" target="_blank">${item.name}</a><span class="next-symbol">-</span>`
      }
    }
  }
}
